import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import {UserService} from '../../../../user.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
@Component({
  selector: 'app-awsop-lab1',
  templateUrl: './awsop-lab1.component.html',
  styleUrls: ['./awsop-lab1.component.css']
})
export class AwsopLab1Component implements OnInit {
  accessKey = '';
  secretAccessKey = '';
  labState = {};

  constructor(public ngxSmartModalService: NgxSmartModalService, private userService: UserService, private router: Router) { }

  ngOnInit() {

  }

  sendKey() {
    if (this.accessKey.length == 0 || this.secretAccessKey.length == 0 ) {
      alert("Missing valid access key and secret access key.");
      return;
    }


    this.userService.user.secretAccessKey = this.secretAccessKey;
    this.userService.user.accessKey = this.accessKey;

    this.userService.createUser(this.userService.user).subscribe(
      res => {
        let pass = res['checks']["overallPass"]
        this.labState['lab1'] = pass;
        if (pass) {
          alert('You passed!!')
        } else {
          alert("You failed lab 1. Please try again.")
        }
      },
      err => {
        console.log("Error occured", err);
      }
    );

  }

  openPopup() {
    this.ngxSmartModalService.getModal('infoModal').open()
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab1/awsop-lab1.component.ts